import { render, staticRenderFns } from "./LichSuDichVuDiemDenForm.vue?vue&type=template&id=bdaf6086&scoped=true"
import script from "./LichSuDichVuDiemDenForm.vue?vue&type=script&lang=js"
export * from "./LichSuDichVuDiemDenForm.vue?vue&type=script&lang=js"
import style0 from "./LichSuDichVuDiemDenForm.vue?vue&type=style&index=0&id=bdaf6086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdaf6086",
  null
  
)

export default component.exports